import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Injectable ({ providedIn: 'root'})
export class SkillMatrixService extends Subject<DataStateChangeEventArgs>  {
    private httpClient: HttpClient;
    constructor(private handler: HttpBackend,
       private http: HttpClient, 
       ) { 
      super();
      this.httpClient = new HttpClient(handler);
    }
  
    handleError(error: HttpErrorResponse) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `Error: ${error.error.message}`;
      } else {
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //  window.alert(errorMessage);
    console.log("Error:",errorMessage);
    return throwError(errorMessage);
    }

    //Get All Skill Matrix for All Users
    getUserSkillMetrix(): Observable<Object> {
        return this.http.get(`${environment.apiUrl}/userSkillMetrix`).pipe(catchError(this.handleError));
    }

    getSkillMap(): Observable<Object> {
      return this.http.get(`${environment.apiUrl}/skillMap`).pipe(catchError(this.handleError));
    }

    //Create New Skill
    getSkills(): Observable<Object> {
        return this.http.get(`${environment.apiUrl}/skills`).pipe(catchError(this.handleError));
    }

    //Create New Skill
    createSkills(skill: Object): Observable<Object> {
        return this.http.post(`${environment.apiUrl}/skills`, skill).pipe(catchError(this.handleError));
    }
  
    //Update Existing Skill
    updateSkills(skill: Object, skillId: String): Observable<Object> {
        return this.http.put(`${environment.apiUrl}/skills/${skillId}`, skill).pipe(catchError(this.handleError));
    }
    
    //Create Skill Matrix/Value
    createUserSkillValues(skillValue: Object): Observable<Object> {
        return this.http.post(`${environment.apiUrl}/userSkillValues`, skillValue).pipe(catchError(this.handleError));
    }

    //Create Skill Matrix/Value
    createUserSkillValuesByName(skill: Object): Observable<Object> {
      return this.http.post(`${environment.apiUrl}/userSkillValues`, skill).pipe(catchError(this.handleError));
  }

    //Update Existing Skill Matrix/Value
    updateUserSkillValues(skillValue: Object, skillId: String): Observable<Object> {
        return this.http.put(`${environment.apiUrl}/userSkillValues/${skillId}`, skillValue).pipe(catchError(this.handleError));
    }

}